import { FC } from "react";

import { SelectOptionProps } from "./Select.types";

const SelectOption: FC<SelectOptionProps> = ({ children, ...props }) => {
	return <option {...props}>{children}</option>;
};

export default SelectOption;
